import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'core/libs/router';
import { Helmet } from 'core/libs/helmet';

import RcmEventsSender from 'core/components/RcmEventsSender';
import EmptyWrapper from 'core/components/EmptyWrapper';


/**
 * @author Aleksey Rezakov <a.rezakov@rambler-co.ru>
 */
function Page(props, context) {
  const {
    children,
    title,
    description,
    canonicalPath,
    skipRcm,
    location: {
      pathname,
    },
  } = props;

  const { host, amp } = context;

  const resolvedPathname = canonicalPath || pathname;
  const locationPath = resolvedPathname === '/' ? '' : resolvedPathname.toLowerCase();
  const RcmWrapper = skipRcm ? EmptyWrapper : RcmEventsSender;

  return (
    <Fragment>
      <Helmet>
        {title && (
          <title>{title}</title>
        )}
        {description && (
          <meta name='description' content={description} />
        )}
        {!amp && (
          <link rel='canonical' href={`https://${host + locationPath}`} />
        )}
      </Helmet>
      <RcmWrapper hubpageview={{ hubId: pathname }}>
        {children}
      </RcmWrapper>
    </Fragment>
  );
}

Page.propTypes = {
  /**
   * Title страницы
   */
  title: PropTypes.string,

  /**
   * Meta description
   */
  description: PropTypes.string,

  /**
   * Относительный путь от корня сайта: `link[rel='canonical']`
   */
  canonicalPath: PropTypes.string,

  /**
   * Отключить отправку событий RCM.
   */
  skipRcm: PropTypes.bool,

  /** @ignore */
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

Page.contextTypes = {
  host: PropTypes.string.isRequired,
  amp: PropTypes.bool,
};

const PageWithHOCs = withRouter(Page);

PageWithHOCs.displayName = 'Page';

export { Page as StorybookComponent };
export default PageWithHOCs;
